import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filteredBy } from "../../features/filter/filterSlice";

export default function FilterBlogs () {
    const { value } = useSelector(state => state.filter)
    const dispatch = useDispatch();

    const [selectedOption, setSelectedOption] = useState(value);
    const handleFilterChange = (option) => {
        setSelectedOption(option);
        dispatch(filteredBy(option));
    }

    return (
        <div className="sidebar-content">
            <h4>Filter</h4>
            <div className="radio-group">
                <div>
                    <input
                        type="radio"
                        name="filter"
                        id="lws-all"
                        className="radio"
                        checked={selectedOption === "All"}
                        value="All"
                        onChange={e => handleFilterChange(e.target.value)}
                    />
                    <label htmlFor="lws-all">All</label>
                </div>
                <div>
                    <input
                        type="radio"
                        name="filter"
                        id="lws-saved"
                        className="radio"
                        checked={selectedOption === "Saved"}
                        value="Saved"
                        onChange={e => handleFilterChange(e.target.value)}
                    />
                    <label htmlFor="lws-saved">Saved</label>
                </div>
            </div>
        </div>
    );
}